import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { desktopRoutes, pathConstants } from '../../../router/pathConstants';
import Config from '../../../config';

const AppUpdatesNotification = () => {
  return (
    <Container>
      <IconWrapper>
        <img src={Config.ImageAssets.notifications.info} alt="icon" />
      </IconWrapper>
      <MessageWrapper>
        <Message>{Config.TextStrings.appUpdatesMessage}</Message>
      </MessageWrapper>
      <ButtonLink
        to={isMobile ? pathConstants.appUpdates : desktopRoutes.appUpdates}
      >
        {Config.TextStrings.moreInfoButton}
      </ButtonLink>
      <Close>
        <img src={Config.ImageAssets.notifications.close} alt="close" />
      </Close>
    </Container>
  );
};

const Container = styled.div`
  color: white;
  background-color: ${Config.Color.slateGrey};
  min-height: 80px;
  text-align: center;
  width: 100%;
  padding: ${isMobile ? 0 : '16px'};
  margin: ${isMobile ? '8px 8px 0 8px' : '12px 12px 0 12px'};
  display: grid;
  grid-template-columns: ${isMobile
    ? '60px auto 60px'
    : '80px auto 210px 80px'};
  grid-template-rows: ${isMobile ? 2 : 1};
  justify-items: center;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
`;

const IconWrapper = styled.div`
  align-self: center;
`;

const MessageWrapper = styled.div`
  align-self: center;
  justify-self: left;
  margin-top: ${isMobile ? '12px' : 0};
`;

const Message = styled.div`
  text-align: left;
  font-size: ${isMobile ? '12px' : '16px'};
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

const ButtonLink = styled(Link)`
  background-color: ${Config.Color.whiteDimmed};
  align-self: center;
  border-radius: 22px;
  padding: 13px 33px;
  color: ${Config.Color.white};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  grid-row-start: ${isMobile ? 2 : 1};
  grid-column-start: ${isMobile ? 2 : 3};
  margin: ${isMobile ? '12px' : 0};
  &:hover {
    text-decoration: none;
    color: ${Config.Color.white};
  }
`;

const Close = styled.div`
  align-self: center;
`;

export default AppUpdatesNotification;
